import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { State, RootAction } from 'store/state';
import { navigateTo } from 'store/state/router/actions';
import { resolvedStrictLocalDocSelector } from 'store/state/domainData/selectors';
import { IAutocompleteCity } from 'utils/entities';
import { Route } from 'config/routes';
import { MadadSearchPage } from './MadadSearchPage';
import {
  madadSearchAgentsCardsSelector,
  madadSearchOfficesCardsSelector,
  isLoadingMadadSearchSelector,
} from 'store/state/domainData/selectors/madadRenew';
import { madadLocalDocSelector } from 'store/state/selectors/madad';


const isLoadingSelector = createSelector([
  isLoadingMadadSearchSelector,
  resolvedStrictLocalDocSelector,
], (loadingMadad, localDoc) => loadingMadad || !localDoc);

const mapStateToProps = (state: State) => {
  return ({
    localDoc: madadLocalDocSelector(state),
    agents: madadSearchAgentsCardsSelector(state),
    agencies: madadSearchOfficesCardsSelector(state),
    isLoading: isLoadingSelector(state),
  });
};

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  onSearchChange: (value: IAutocompleteCity) => {
    dispatch(navigateTo(Route.MadadSearchPage, { id: value.docId }, { replace: true }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MadadSearchPage);
